const KEYBOARD_OPEN_TIMEOUT_MS = 2000;
// ignore small viewport changes (URL bar collapse, scrollbars) — only react to the on-screen keyboard
const KEYBOARD_MIN_HEIGHT_PX = 100;
const VISIBLE_MARGIN_PX = 8;

/**
 * Keeps an element (typically an input plus the error message rendered below it) visible when the
 * on-screen keyboard opens after a programmatic focus.
 */
export function keepVisibleAboveKeyboard(
	element: HTMLElement,
	{ bottomAllowancePx = 0 }: { bottomAllowancePx?: number } = {},
): void {
	const viewport = window.visualViewport;
	if (!viewport) return;
	const initialHeight = viewport.height;

	const cleanup = () => {
		viewport.removeEventListener('resize', onResize);
		clearTimeout(timer);
	};

	const onResize = () => {
		if (initialHeight - viewport.height < KEYBOARD_MIN_HEIGHT_PX) return;
		const { top, bottom } = element.getBoundingClientRect();
		const visibleTop = viewport.offsetTop;
		const visibleBottom = viewport.offsetTop + viewport.height;
		const overflow = bottom + bottomAllowancePx + VISIBLE_MARGIN_PX - visibleBottom;
		// never push the element's top edge above the visible area while revealing its bottom edge
		const maxScroll = Math.max(top - visibleTop - VISIBLE_MARGIN_PX, 0);
		if (overflow > 0) window.scrollBy({ top: Math.min(overflow, maxScroll) });
		cleanup();
	};

	viewport.addEventListener('resize', onResize);
	const timer = setTimeout(cleanup, KEYBOARD_OPEN_TIMEOUT_MS);
}
